<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasSupplier="true"
      :hasTradeStatusType="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["simple", "detail", "statistic"],
      reportType: "simple",
    };
  },
  components: {
    conditionPart,
  },
  computed: {
    columns() {
      if (this.reportType == "detail") {
        return [
          { name: "SupplierNumber" },
          { name: "SupplierName" },
          { name: "PurchaseNumber" },
          { name: "PurchaseDate" },
          { name: "BuyerNumber" },
          { name: "BuyerName" },
          { name: "TradeType" },
          { name: "FoodNumber" },
          { name: "FoodName" },
          { name: "Qty" },
          { name: "Cost" },
          { name: "Total" },
          { name: "AllTotal" },
          { name: "YTaxPrice" },
          { name: "TaxPrice" },
        ];
      } else if (this.reportType == "simple") {
        return [
          { name: "SupplierNumber" },
          { name: "SupplierName" },
          { name: "PurchaseDate" },
          { name: "PurchaseNumber" },
          { name: "BuyerNumber" },
          { name: "BuyerName" },
          { name: "TradeType" },
          { name: "InvoiceNumber" },
          { name: "Total" },
          { name: "YTaxPrice" },
          { name: "TaxPrice" },
        ];
      } else if (this.reportType == "statistic") {
        return [
          { name: "SupplierNumber" },
          { name: "SupplierName" },
          { name: "Total", headerText: "總金額" },
          { name: "PurchaseTotal" },
          { name: "PurchaseReturnTotal" },
          { name: "YTaxPrice" },
          { name: "TaxPrice" },
          { name: "NTaxPrice" },
          { name: "ZTaxPrice" },
        ];
      }
    },
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getSupplier(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getSupplier(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printSupplier(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;

      const vm = this;
      this.$api.reports.getSupplier(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
